import { Button, Popover } from 'antd';
import React from 'react';
import styles from './ScheduleItem.module.scss';
import { Radio } from '../../../../../../../components/Radio/Radio';
import { ReactComponent as CalendarIcon } from '../../../../../../../resource/CalendarIcon.svg';

const ScheduleActions = ({
  showDuplicate,
  onEdit,
  onDuplicate,
  onDelete,
  onAction,
}) => {
  const actions = [
    {
      key: 'edit',
      icon: 'edit',
      text: 'Редактировать',
      onClick: onEdit,
    },
    showDuplicate && {
      key: 'duplicate',
      icon: 'copy',
      text: 'Дублировать',
      onClick: onDuplicate,
    },
    {
      key: 'delete',
      icon: 'delete',
      text: 'Удалить',
      danger: true,
      onClick: onDelete,
    },
  ].filter(Boolean);

  const handleActionClick = (event, action) => {
    event.preventDefault();
    event.stopPropagation();

    if (typeof action.onClick === 'function') {
      action.onClick();
    }

    if (typeof onAction === 'function') {
      onAction();
    }
  };

  return (
    <div className={styles.actionMenu}>
      {actions.map((action) => (
        <Button
          key={action.key}
          type="link"
          icon={action.icon}
          className={`${styles.actionMenuBtn} ${
            action.danger ? styles.actionMenuBtnDanger : ''
          }`.trim()}
          onClick={(event) => handleActionClick(event, action)}
        >
          {action.text}
        </Button>
      ))}
    </div>
  );
};

export const ScheduleItem = ({
  departmentName,
  periodText,
  quantityOfWorkers,
  schedule,
  onSelect,
  isSelected,
  showDetails = true,
  showActions = true,
  closeOverlaysKey,
  onActionPopoverVisibleChange,
  onEdit,
  onDuplicate,
  onDelete,
}) => {
  const [isActionsVisible, setIsActionsVisible] = React.useState(false);
  const handleChange = (e) => {
    if (e.target.checked) {
      onSelect(schedule);
    }
  };

  const handleEdit = () => {
    if (typeof onEdit === 'function') {
      onEdit(schedule);
    }
  };

  const handleDelete = () => {
    if (typeof onDelete === 'function') {
      onDelete(schedule);
    }
  };

  const handleDuplicate = () => {
    if (typeof onDuplicate === 'function') {
      onDuplicate(schedule);
    }
  };

  React.useEffect(() => {
    setIsActionsVisible(false);
    if (typeof onActionPopoverVisibleChange === 'function') {
      onActionPopoverVisibleChange(false);
    }
  }, [closeOverlaysKey, onActionPopoverVisibleChange]);

  React.useEffect(
    () => () => {
      if (typeof onActionPopoverVisibleChange === 'function') {
        onActionPopoverVisibleChange(false);
      }
    },
    [onActionPopoverVisibleChange]
  );

  const handleActionsVisibleChange = (visible) => {
    setIsActionsVisible(visible);

    if (typeof onActionPopoverVisibleChange === 'function') {
      onActionPopoverVisibleChange(visible);
    }
  };

  const action = showActions ? (
    <Popover
      trigger="click"
      placement="bottomRight"
      visible={isActionsVisible}
      onVisibleChange={handleActionsVisibleChange}
      content={
        <ScheduleActions
          showDuplicate={showDetails}
          onEdit={handleEdit}
          onDuplicate={handleDuplicate}
          onDelete={handleDelete}
          onAction={() => handleActionsVisibleChange(false)}
        />
      }
    >
      <Button className={styles.actionBtn} icon="ellipsis" />
    </Popover>
  ) : null;

  return (
    <li className={styles.item}>
      <Radio
        checked={isSelected}
        onChange={handleChange}
        value={schedule.id}
        name="work-schedule"
        className={styles.root}
        icon={CalendarIcon}
        action={action}
      >
        <div className={styles.departmentContent}>
          <span className={styles.departmentName}>{departmentName}</span>
          {showDetails && (
            <span className={styles.departmentInfo}>
              <span className={styles.quantityOfWorkers}>
                {quantityOfWorkers} исполнителей
              </span>
              {periodText && (
                <span className={styles.period}>{periodText}</span>
              )}
            </span>
          )}
        </div>
      </Radio>
    </li>
  );
};
